import * as React from "react"
import {CSSProperties} from "react"
import {ClickableProps} from "../../common/props/ClickableProps";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import "./deleteInputAddon.scss"
import IconLarge from "../../../hiberUiKit/src/atoms/Icon/IconLarge";
import classNames = require("classnames");

interface ComponentProps {
	/**
	 * Addon position relative to the input.
	 */
	addonPosition?: "left" | "right";
	/**
	 * Callback action for delete addon click.
	 */
	onDeleteClick?: () => void;
	/**
	 * Custom CSS properties.
	 */
	style?: CSSProperties;
}

type Props = ComponentProps & ClickableProps

/**
 * Display children with optional button addon from left / right side.
 */
export default class DeleteInputAddon extends React.Component<Props, {}> {
	render() {
		const classFromProps = classNames({
			"c-delete-input-addon": true,
			"has-left-addon": this.props.addonPosition === "left",
			"has-right-addon": this.props.addonPosition === "right",
		});
		return (
			<div className={classFromProps} onClick={this.props.onClick} style={this.props.style}>
				{this.renderLeftAddon()}
				{this.props.children}
				{this.renderRightAddon()}
			</div>
		);
	}

	renderLeftAddon() {
		if (this.props.addonPosition == "left") {
			return (
				<div className="input-group-prepend" onClick={this.props.onDeleteClick}>
					<IconLarge icon={Icon.X} variant={"scarlet"}/>
				</div>
			);
		}
	}

	renderRightAddon() {
		if (this.props.addonPosition == "right") {
			return (
				<div className="input-group-append" onClick={this.props.onDeleteClick}>
					<IconLarge icon={Icon.X} variant={"scarlet"}/>
				</div>
			);
		}
	}
}